module.exports = __webpack_public_path__ + "img/zoom-in-icon.427959c3.svg";